module.exports = __webpack_public_path__ + "assets/favicons/favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/favicon-32x32.png
// module id = YzbZ
// module chunks = 1